import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=5b81fa7a&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=5b81fa7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81fa7a",
  null
  
)

export default component.exports